export const Button = {
  baseStyle: {
    fontWeight: '500',
    borderRadius: 'base',
  },

  sizes: {
    sm: {
      fontSize: 'sm',
      px: 4,
      py: 3,
    },
    md: {
      fontSize: 'md',
      px: 6,
      py: 4,
    },
  },

  variants: {
    outline: {
      border: '2px solid',
      borderColor: 'brand.400',
      color: 'brand.400',
    },
    solid: {
      bg: 'brand.400',
      color: 'white',
      _hover: {
        bg: 'brand.500',
        color: '#fff',
      },
    },
  },

  defaultProps: {
    size: 'md',
    variant: 'solid',
  },
};
